let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("emqoL")).then(() => parcelRequire('dteRd'));